const countOptions = {
    responsive: true,
    title: {
        display: false
    },
    legend: {
        display: false
    },
    scales: {
        xAxes: [{
            type: 'time',
            display: true,
            scaleLabel: {
                display: false,
                labelString: "Date"
            },
            time: {
                displayFormats: {
                    month: "MMM YY"
                },
                unit: 'month'
            },
            ticks: {
                fontColor: "#6d4f7f",
                fontSize: 11,
                fontStyle: "normal",
                fontFamily: "Roboto",
                maxRotation: 0,
                minRotation: 0,
                maxTicksLimit: 6,
                autoSkip: true
            },
            gridLines: {
                display: false ,
                color: "#FFFFFF"
              },
        }],
        yAxes: [{
            ticks: {
                beginAtZero: true,
                fontColor: "#6d4f7f",
                fontSize: 11,
                fontStyle: "normal",
                fontFamily: "Roboto",
                maxTicksLimit: 5,
                autoSkip: true
            },
            display: true,
            scaleLabel: {
                display: false,
                labelString: "£",
            },
            gridLines: {
                display: true ,
                color: "#F6F6F6"
              },
        }]
    }
};

const salesOptions = {
    responsive: true,
    title: {
        display: false
    },
    legend: {
        display: false
    },
    tooltips: {
        callbacks: {
            label: function(tooltipItem, data) {
                return tooltipItem.yLabel.toLocaleString("en-GB",{style:"currency", currency:"GBP"});
            }
        }
    },
    scales: {
        xAxes: [{
            type: 'time',
            display: true,
            scaleLabel: {
                display: false,
                labelString: "Date"
            },
            time: {
                displayFormats: {
                    month: "MMM YY"
                },
                unit: 'month'
            },
            ticks: {
                fontColor: "#6d4f7f",
                fontSize: 11,
                fontStyle: "normal",
                fontFamily: "Roboto",
                maxRotation: 0,
                minRotation: 0,
                maxTicksLimit: 6,
                autoSkip: true
            },
            gridLines: {
                display: false ,
                color: "#FFFFFF"
              },
        }],
        yAxes: [{
            ticks: {
                beginAtZero: true,
                fontColor: "#6d4f7f",
                fontSize: 11,
                fontStyle: "normal",
                fontFamily: "Roboto",
                maxTicksLimit: 5,
                autoSkip: true,
                callback: function(value, index, values) {
                    return value.toLocaleString("en-GB",{style:"currency", currency:"GBP"});
                  }
            },
            display: true,
            scaleLabel: {
                display: false,
                labelString: "£",
            },
            gridLines: {
                display: true ,
                color: "#F6F6F6"
              },
        }]
    }
};

const options = {countOptions, salesOptions};
export default options;


/** WEBPACK FOOTER **
 ** ./src/chartOptions.js
 **/